import React from "react";

/**
 * @param {{ rating: number; size?: 'sm' | 'md' | 'lg'; className?: string }} props
 */
const StarRating = ({ rating, size = "sm", className = "" }) => {
  const r = Math.round(Math.min(5, Math.max(0, Number(rating) || 0)));
  const cls =
    size === "lg" ? "h-5 w-5" : size === "md" ? "h-4 w-4" : "h-3.5 w-3.5";

  return (
    <span
      className={`inline-flex gap-0.5 ${className}`}
      aria-label={`${r} von 5 Sternen`}
    >
      {[1, 2, 3, 4, 5].map((i) => (
        <svg
          key={i}
          className={`${cls} ${i <= r ? "text-amber-400" : "text-[#e5e7eb]"}`}
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden
        >
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ))}
    </span>
  );
};

export default StarRating;
